const MessageSkeleton = () => {
  const skeletonMessages = Array(6).fill(null);

  return (
    <div
      style={{
        flex: 1,
        overflowY: "auto",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      {skeletonMessages.map((_, idx) => (
        <div
          key={idx}
          style={{
            display: "flex",
            flexDirection: idx % 2 === 0 ? "row" : "row-reverse",
            alignItems: "flex-start",
            gap: "12px",
          }}
        >
          {/* Avatar */}
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "#ddd",
              flexShrink: 0,
            }}
          ></div>

          {/* Message Skeleton */}
          <div style={{ flex: 1 }}>
            {/* Header Skeleton */}
            <div
              style={{
                height: "16px",
                width: "64px",
                backgroundColor: "#ddd",
                marginBottom: "8px",
                borderRadius: "4px",
              }}
            ></div>

            {/* Bubble Skeleton */}
            <div
              style={{
                width: "200px",
                height: "64px",
                backgroundColor: "#ddd",
                borderRadius: "12px",
              }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessageSkeleton;
